import { TABS_VARIANTS, ACCORDION_SIZES, ACCORDION_VARIANTS, ALERT_VARIANTS, BREADCRUMB_SIZES, BREADCRUMB_VARIANTS, BUTTON_GROUP_ORIENTATIONS, BUTTON_ICONS, BUTTON_SIZES, BUTTON_VARIANTS, CHECKBOX_VARIANTS, CODE_RECIPE_COLORS, CODE_SIZES, CODE_VARIANTS, CONTROL_SIZES, DIVIDER_COLORS, DIVIDER_ORIENTATIONS, DIVIDER_SIZES, DIVIDER_VARIANTS, FLYOUT_ITEM_STATES, FONT_WEIGHTS, FORM_ORIENTATIONS, INPUT_VARIANTS, LINK_UNDERLINES, MESSAGE_PAIR_USER_VARIANTS, MODAL_PLACEMENTS, MODAL_SCROLL_BEHAVIORS, MODAL_SIZES, SCROLL_AREA_GUTTERS, SCROLL_AREA_ORIENTATIONS, SCROLL_AREA_SIZES, SCROLL_AREA_VARIANTS, SEGMENTED_CONTROL_ITEM_CONTENTS, SEGMENTED_CONTROL_LAYOUTS, SEGMENTED_CONTROL_VARIANTS, SELECT_VARIANTS, SPINNER_SIZES, STACK_ALIGNMENTS, STACK_DIRECTIONS, STACK_GAPS, STACK_JUSTIFICATIONS, TABLE_CAPTION_SIDES, TABLE_LAYOUTS, TABLE_SIZES, TABLE_VARIANTS, TEXT_ALIGNMENTS, TEXT_RECIPE_COLORS, TEXT_RECIPE_WEIGHTS, TEXT_SIZES, TEXTAREA_RESIZES, TOAST_ICON_STYLES, TOAST_POSITIONS, TOAST_STATUSES, } from '@smoothie-framework/ui-core/schemas/component-vocabulary';
export const EMPTY_RECIPE_VARIANTS = Object.freeze({});
export const BUTTON_RECIPE_VARIANTS = Object.freeze({
    variant: BUTTON_VARIANTS,
    size: BUTTON_SIZES,
    disabled: Object.freeze([true, false]),
    loading: Object.freeze([true, false]),
    fullWidth: Object.freeze([true, false]),
    icon: BUTTON_ICONS,
});
export const BUTTON_GROUP_RECIPE_VARIANTS = Object.freeze({
    orientation: BUTTON_GROUP_ORIENTATIONS,
    attached: Object.freeze([true, false]),
});
export const NAV_TREE_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
});
export const BREADCRUMB_RECIPE_VARIANTS = Object.freeze({
    size: BREADCRUMB_SIZES,
    variant: BREADCRUMB_VARIANTS,
});
export const INPUT_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    variant: INPUT_VARIANTS,
    disabled: Object.freeze([true, false]),
    invalid: Object.freeze([true, false]),
});
export const FIELD_RECIPE_VARIANTS = Object.freeze({
    orientation: FORM_ORIENTATIONS,
});
export const FIELD_GROUP_RECIPE_VARIANTS = Object.freeze({
    orientation: FORM_ORIENTATIONS,
});
export const FIELD_LABEL_RECIPE_VARIANTS = Object.freeze({
    required: Object.freeze([true, false]),
});
export const FIELD_ERROR_RECIPE_VARIANTS = Object.freeze({
    align: TEXT_ALIGNMENTS,
});
export const FIELD_SET_RECIPE_VARIANTS = Object.freeze({
    orientation: FORM_ORIENTATIONS,
});
export const CHECKBOX_GROUP_RECIPE_VARIANTS = Object.freeze({
    orientation: FORM_ORIENTATIONS,
});
export const RADIO_GROUP_RECIPE_VARIANTS = Object.freeze({
    orientation: FORM_ORIENTATIONS,
});
export const SEGMENTED_CONTROL_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    variant: SEGMENTED_CONTROL_VARIANTS,
    itemContent: SEGMENTED_CONTROL_ITEM_CONTENTS,
    orientation: FORM_ORIENTATIONS,
    layout: SEGMENTED_CONTROL_LAYOUTS,
});
export const STACK_RECIPE_VARIANTS = Object.freeze({
    direction: STACK_DIRECTIONS,
    gap: STACK_GAPS,
    align: STACK_ALIGNMENTS,
    justify: STACK_JUSTIFICATIONS,
    wrap: Object.freeze([true, false]),
});
export const TEXT_RECIPE_VARIANTS = Object.freeze({
    size: TEXT_SIZES,
    weight: TEXT_RECIPE_WEIGHTS,
    align: TEXT_ALIGNMENTS,
    color: TEXT_RECIPE_COLORS,
});
export const LINK_RECIPE_VARIANTS = Object.freeze({
    size: TEXT_SIZES,
    underline: LINK_UNDERLINES,
    variant: Object.freeze(['primary', 'secondary', 'ghost']),
});
export const TEXTAREA_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    variant: INPUT_VARIANTS,
    resize: TEXTAREA_RESIZES,
    disabled: Object.freeze([true, false]),
    invalid: Object.freeze([true, false]),
});
export const COMPOSER_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
});
export const STREAMING_TEXT_RECIPE_VARIANTS = Object.freeze({});
export const MESSAGE_PAIR_RECIPE_VARIANTS = Object.freeze({
    variant: MESSAGE_PAIR_USER_VARIANTS,
});
export const TOOL_CALL_RECIPE_VARIANTS = Object.freeze({});
export const CHECKBOX_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    variant: CHECKBOX_VARIANTS,
    disabled: Object.freeze([true, false]),
    invalid: Object.freeze([true, false]),
    readOnly: Object.freeze([true, false]),
});
export const RADIO_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    variant: CHECKBOX_VARIANTS,
    disabled: Object.freeze([true, false]),
    invalid: Object.freeze([true, false]),
    readOnly: Object.freeze([true, false]),
});
export const SWITCH_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    disabled: Object.freeze([true, false]),
    checked: Object.freeze([true, false]),
    invalid: Object.freeze([true, false]),
});
export const SELECT_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    variant: SELECT_VARIANTS,
    disabled: Object.freeze([true, false]),
    invalid: Object.freeze([true, false]),
});
export const FLYOUT_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
});
export const FLYOUT_ITEM_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    state: FLYOUT_ITEM_STATES,
    selected: Object.freeze([true, false]),
    disabled: Object.freeze([true, false]),
});
export const MODAL_POSITIONER_RECIPE_VARIANTS = Object.freeze({
    placement: MODAL_PLACEMENTS,
});
export const MODAL_CONTENT_RECIPE_VARIANTS = Object.freeze({
    size: MODAL_SIZES,
    placement: MODAL_PLACEMENTS,
    scrollBehavior: MODAL_SCROLL_BEHAVIORS,
});
export const TABLE_RECIPE_VARIANTS = Object.freeze({
    size: TABLE_SIZES,
    variant: TABLE_VARIANTS,
    striped: Object.freeze([true, false]),
    interactive: Object.freeze([true, false]),
    showColumnBorder: Object.freeze([true, false]),
    stickyHeader: Object.freeze([true, false]),
    layout: TABLE_LAYOUTS,
});
export const TABLE_CAPTION_RECIPE_VARIANTS = Object.freeze({
    side: TABLE_CAPTION_SIDES,
});
export const TABLE_SCROLL_AREA_RECIPE_VARIANTS = Object.freeze({
    frame: Object.freeze(['none', 'outline']),
});
export const TABLE_EMPTY_RECIPE_VARIANTS = EMPTY_RECIPE_VARIANTS;
export const CHART_RECIPE_VARIANTS = Object.freeze({});
export const ACCORDION_RECIPE_VARIANTS = Object.freeze({
    size: ACCORDION_SIZES,
    variant: ACCORDION_VARIANTS,
});
export const ACCORDION_EMPTY_RECIPE_VARIANTS = EMPTY_RECIPE_VARIANTS;
export const DROPDOWN_MENU_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
});
export const DROPDOWN_MENU_TRIGGER_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    disabled: Object.freeze([true, false]),
});
export const DROPDOWN_MENU_CONTENT_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
});
export const DROPDOWN_MENU_ITEM_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    disabled: Object.freeze([true, false]),
    destructive: Object.freeze([true, false]),
    checked: Object.freeze([true, false]),
});
export const DROPDOWN_MENU_LABEL_RECIPE_VARIANTS = Object.freeze({
    inset: Object.freeze([true, false]),
});
export const SPINNER_RECIPE_VARIANTS = Object.freeze({
    size: SPINNER_SIZES,
});
export const PROGRESS_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
});
export const ALERT_RECIPE_VARIANTS = Object.freeze({
    variant: ALERT_VARIANTS,
});
export const TOAST_RECIPE_VARIANTS = Object.freeze({
    status: TOAST_STATUSES,
    iconStyle: TOAST_ICON_STYLES,
});
export const TOASTER_RECIPE_VARIANTS = Object.freeze({
    position: TOAST_POSITIONS,
});
export const LABEL_RECIPE_VARIANTS = Object.freeze({
    size: TEXT_SIZES,
    weight: FONT_WEIGHTS,
});
export const CODE_RECIPE_VARIANTS = Object.freeze({
    variant: CODE_VARIANTS,
    size: CODE_SIZES,
    color: CODE_RECIPE_COLORS,
});
export const CODE_BLOCK_RECIPE_VARIANTS = Object.freeze({
    size: CONTROL_SIZES,
    wrap: Object.freeze([true, false]),
});
export const DIVIDER_RECIPE_VARIANTS = Object.freeze({
    orientation: DIVIDER_ORIENTATIONS,
    variant: DIVIDER_VARIANTS,
    size: DIVIDER_SIZES,
    color: DIVIDER_COLORS,
});
export const SCROLL_AREA_RECIPE_VARIANTS = Object.freeze({
    orientation: SCROLL_AREA_ORIENTATIONS,
    variant: SCROLL_AREA_VARIANTS,
    size: SCROLL_AREA_SIZES,
    gutter: SCROLL_AREA_GUTTERS,
});
export const TABS_RECIPE_VARIANTS = Object.freeze({ variant: TABS_VARIANTS });
//# sourceMappingURL=built-in-component-projection.js.map